import { render, staticRenderFns } from "./DisapprovedReasonCreate.vue?vue&type=template&id=649f9f07"
import script from "./DisapprovedReasonCreate.vue?vue&type=script&lang=js"
export * from "./DisapprovedReasonCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports